import _pt from "prop-types";
import React from "react";
import classNames from "classnames";
import { FILL_COLOR_MAP } from "../../utils/accessibility";
import { Icon } from "../Icon/icon";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ButtonIcon = function ButtonIcon(_ref) {
  var buttonRef = _ref.buttonRef,
      className = _ref.className,
      iconFill = _ref.iconFill,
      iconName = _ref.iconName,
      isDisabled = _ref.isDisabled,
      onClick = _ref.onClick,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size,
      style = _ref.style,
      testSection = _ref.testSection,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["buttonRef", "className", "iconFill", "iconName", "isDisabled", "onClick", "size", "style", "testSection", "title"]);

  // ensure valid fillColor name (in the case that propType errors are ignored)
  var fillColor = iconFill && Object.keys(FILL_COLOR_MAP).includes(iconFill) ? FILL_COLOR_MAP[iconFill] : undefined;

  function handleOnClick(event) {
    if (isDisabled) {
      return;
    }

    onClick && onClick(event);
  } // This component is a bit of a mess and has no Figma component, so this is a stopgap to somewhat fix the sizing
  // Small and medium button sizes are larger than their icons, but the large size button is the same size as the
  // large icon, so we'll use medium sized icons for large size buttons until this is better defined.


  var iconSize = size === "small" ? "small" : "medium";
  return React.createElement("button", _extends({
    className: classNames("oui-button oui-button-icon oui-button-icon__".concat(size, " oui-button--").concat(style), fillColor ? "" : "axiom-button-icon--no-fill", className),
    "data-oui-component": true,
    "data-test-section": testSection,
    disabled: isDisabled,
    onClick: handleOnClick,
    ref: buttonRef,
    title: title,
    type: "button"
  }, props), React.createElement("div", {
    className: "flex flex--dead-center "
  }, React.createElement(Icon, {
    color: fillColor,
    name: iconName,
    size: iconSize,
    title: title
  })));
};

ButtonIcon.propTypes = {
  buttonRef: _pt.any,
  className: _pt.string,
  iconFill: _pt.oneOf(["aqua", "yellow", "default", "green", "orange", "pink", "red", "magenta", "grey", "purple", "black"]),
  iconName: _pt.any,
  isDisabled: _pt.bool,
  onClick: _pt.func,
  size: _pt.oneOf(["small", "medium", "large"]),
  style: _pt.oneOf(["highlight", "danger", "danger-outline", "outline", "plain", "unstyled"]),
  testSection: _pt.string,
  title: _pt.string
};
ButtonIcon.defaultProps = {
  iconName: "add",
  onClick: function onClick() {
    return null;
  },
  size: "medium",
  title: ""
};
export default React.memo(ButtonIcon);